<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <div :class="{ 'existed-mark__type-mark': isMarkTypeNumber, 'existed-mark__type-evaluate': !isMarkTypeNumber }">
        <span
          v-bind="attrs"
          v-on="on"
          @click="() => $emit('on-existed-mark-click')"
          style="font-size: 16px; cursor: pointer"
          :class="{ 'red--text': isEditted }"
        >
          {{ markValue }}
        </span>
      </div>
    </template>
    <span v-html="historyDetail" />
  </v-tooltip>
</template>
<script>
import { get } from 'lodash'
export default {
  props: {
    mark: Object,
    type: {
      type: String,
      default: 'mark'
    }
  },
  computed: {
    markValue() {
      return this.getMarkValueByType(this.mark.value)
    },
    isEditted() {
      return Object.values(get(this.mark, 'history', {})).length > 1
    },
    historyDetail() {
      const history = get(this.mark, 'history', {})
      const historyKeys = Object.keys(history)
      if (historyKeys.length)
        return historyKeys
          .map(date => `${this.$options.filters.ddmmyyyy(date)} - ${this.getMarkValueByType(history[date])}`)
          .join('<br/>')
      return `${this.$options.filters.ddmmyyyy(this.mark.date)} - ${this.getMarkValueByType(this.mark.value)}`
    },
    isMarkTypeNumber() {
      return this.type === 'mark'
    }
  },
  methods: {
    getMarkValueByType(mark = 0) {
      if (this.type === 'mark') return mark
      return this.$options.filters.getEvaluate(mark)
    }
  }
}
</script>
<style lang="scss" scoped>
.existed-mark {
  &__type-mark {
    width: 50px;
  }
  &__type-evaluate {
    width: 90px;
  }
}
</style>
